import OutputQueryContainer from './OutputQueryContainer'

export default OutputQueryContainer
